import { Grid, styled } from '@mui/material';

export const StyledHeaderContainer = styled(Grid)(({ theme }) => ({
  padding: `${theme.convert.pxToRem(15)} ${theme.convert.pxToRem(35)}`,
  background: theme.palette.grey[200],
  height: theme.convert.pxToRem(48),
}));
